"use client";

import { PROFILES } from "@kedaat/definitions";
import type { Profile } from "@kedaat/engine";
import { useId } from "react";
import { PROFILE_STATUS_LABEL } from "@/lib/labels";
import { BookIcon } from "./icons";

export function ProfilePicker({
  profile,
  overrideCount,
  onSelect,
  onResetOverrides,
}: {
  profile: Profile;
  overrideCount: number;
  onSelect: (id: string) => void;
  onResetOverrides: () => void;
}) {
  const id = useId();
  return (
    <div className="rounded-2xl border border-line bg-card px-4 py-3 shadow-sm">
      <div className="flex items-baseline justify-between gap-2">
        <label htmlFor={id} className="flex items-center gap-1 text-xs font-medium text-muted">
          <BookIcon className="size-3.5" />
          שיטה
        </label>
        {overrideCount > 0 && (
          <button
            type="button"
            onClick={onResetOverrides}
            className="inline-flex min-h-6 items-center px-1 text-xs font-medium text-accent underline-offset-2 hover:underline"
          >
            {overrideCount === 1 ? "זמן אחד מותאם" : `${overrideCount} זמנים מותאמים`} · איפוס
          </button>
        )}
      </div>
      <select
        id={id}
        value={profile.id}
        onChange={(e) => onSelect(e.target.value)}
        className="mt-0.5 w-full cursor-pointer bg-transparent text-lg font-medium focus:outline-none"
      >
        {PROFILES.map((p) => (
          <option key={p.id} value={p.id}>
            {p.label.he}
          </option>
        ))}
      </select>
      {/* The full description can be long, so it opens on demand. */}
      <details className="group mt-1">
        <summary className="flex cursor-pointer list-none items-center gap-2 text-xs">
          <span className="rounded-full bg-warn-soft px-2 py-0.5 font-medium text-warn">
            {PROFILE_STATUS_LABEL[profile.status]}
          </span>
          <span className="text-accent underline-offset-2 hover:underline">
            <span className="group-open:hidden">על השיטה</span>
            <span className="hidden group-open:inline">סגירה</span>
          </span>
        </summary>
        <p className="mt-1.5 text-xs leading-relaxed text-muted">{profile.description.he}</p>
        {profile.notes && (
          <p className="mt-1 text-xs leading-relaxed text-muted">{profile.notes.he}</p>
        )}
      </details>
    </div>
  );
}
